export default () => {
  const productDropdowns = document.querySelectorAll('[data-categoryList="productCategory"]');

  if(productDropdowns) {
    productDropdowns.forEach(item => {
      item.addEventListener('change', (e) => {
        document.location.href = (e.target.value);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./themes/app/assets/js/modules/dropdownCategory.js